import {useAxios} from "./useAxios";
import useSWRInfinite from "swr/infinite";
import {useLoading} from "./useLoading";



export default function useKennisitems(ingelogdeGebruikerId, cat, prod, typen, vid, taggroep, tekst, unlock, dash, inhoud, vers, kenmerk, fav, initData = []) {
    const aantalPerPagina = 20;

    const {get} = useAxios()
    const fetcher = async (url, pageIndex) => {
        const response = await get(url);
        let toReturn =  response?.data
        return toReturn
    };

    const {
        data,
        mutate,
        size,
        setSize,
        isValidating,
        isLoading
    } = useSWRInfinite(
        index => {
            //if (previousPageData && !previousPageData.length) return null // reached the end
            let filterObject = {
                aantalPerPagina: aantalPerPagina,
                page: index + 1
            }
            if (cat) filterObject.categorie = parseInt(cat)
            if (taggroep) filterObject.taggroep = parseInt(taggroep)
            if (dash) filterObject.dash = dash
            if (tekst) filterObject.tekst = tekst
            if (fav) filterObject.showBookmarked = true
            if (vid) filterObject.filterVideo = true
            if (unlock) filterObject.autorisatie = unlock.split(',').map(x => parseInt(x))
            if (prod) filterObject.product = prod.split(',').map(x => parseInt(x))
            if (inhoud === 'release') {
                filterObject.typen = [3]
                if (vers) filterObject.versies = vers.split(',')
                if (kenmerk) filterObject.kenmerk = kenmerk.split(',').map(x => parseInt(x))
            } else {
                filterObject.notTypen = [3]
                if (typen) filterObject.typen = typen.split(',').map(x => parseInt(x))
            }
            if (ingelogdeGebruikerId) filterObject.gbrId = ingelogdeGebruikerId
            const urlFilters = new URLSearchParams(filterObject).toString();
            return `/wiki/zoeken?${urlFilters}`;
        }, fetcher, {fallbackData: [initData],
            refreshInterval: 0,
            revalidateIfStale: true,
            revalidateOnReconnect: true,
            revalidateOnFocus: false
        }
    );
    const kennisitems = data ? [].concat(...data) : []
    const isLoadingMore = isLoading || (size > 0 && data && typeof data[size - 1] === "undefined");
    const isEmpty = data?.[0]?.length === 0;
    const isReachingEnd = isEmpty || (kennisitems && kennisitems[kennisitems.length - 1]?.data.length < aantalPerPagina);
    const isRefreshing = isValidating && data && data.length === size;
    const total = !data || isEmpty ? 0 : data[0].total

    return {
        data: kennisitems,
        isLoading,
        isLoadingMore,
        isReachingEnd,
        isRefreshing,
        mutate, // if the user makes changes to the current list, call this function to revalidate the list
        size, // aka page
        setSize, // aka setPage
        total
    };
}